export const SEGUNDO_ESCALON_LOGO_SRC =
  'https://files.tnonetwork.com/shows/logo/2doescalon.png';
export const SEGUNDO_ESCALON_COVER_SRC =
  'https://files.tnonetwork.com/shows/ondemand_main/2doescalon.jpg';
